// import { createMuiTheme } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';

const themeDefault = createTheme({
  palette: {
    primary: {
      light: '#5dabdb',
      main: '#004b9a',
      dark: '#0077ee',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#3030cc',
      main: '#3030cc',
      dark: '#aaffaa',
      contrastText: '#ffffff',
    },
    typography: {
      useNextVariants: true,
    }
  }
});

const themeDefault2 = createTheme({
  palette: {
    primary: {
      light: '#191970',
      main: '#191970',
      dark: '#3030ee',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#3030cc',
      main: '#3030cc',
      dark: '#aaffaa',
      contrastText: '#ffffff',
    },
    typography: {
      useNextVariants: true,
    }
  }
});

const themes = {
  default: themeDefault,
  light: themeDefault2,
};
export default themes;
